import svg from './row-svg/cross-v2.svg';
import { FixMe } from '@greenkub-fronts/shared/interface';

export function CrossV2Icon(props: FixMe) {
  return <img {...props} src={svg} alt="svg" />;
}

export default CrossV2Icon;
